/* eslint-disable max-len */
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PhoneIcon = function PhoneIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    enableBackground: "new 0 0 90 90",
    viewBox: "0 0 90 90",
    role: "presentation",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Phone Icon"
    }), /*#__PURE__*/_jsxs("g", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [/*#__PURE__*/_jsx("path", {
        d: "m17.7 28h28.4c2.5 0 4.5 2 4.5 4.5v50.2c0 2.5-2 4.5-4.5 4.5h-28.4c-2.5 0-4.5-2-4.5-4.5v-50.2c-.1-2.5 2-4.5 4.5-4.5z",
        strokeWidth: "4.91"
      }), /*#__PURE__*/_jsxs("g", {
        strokeWidth: "5",
        children: [/*#__PURE__*/_jsx("path", {
          d: "m50.1 15.4c3.4-.1 6.8 1.2 9.4 3.4s4.3 5.3 4.9 8.7"
        }), /*#__PURE__*/_jsx("path", {
          d: "m50.6 2.8c6.4.3 12.6 2.8 17.4 7.1 4.7 4.3 7.9 10.2 8.9 16.6"
        }), /*#__PURE__*/_jsx("path", {
          d: "m24.5 30h14.7"
        })]
      })]
    })]
  });
};

export default /*#__PURE__*/memo(PhoneIcon);